import React, { useState } from "react";
import "../PrivacyPolicy/PrivacyPolicy.css";

const LegalInquiries = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    organization: "",
    inquiryType: "",
    subject: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Simulate API call
    setTimeout(() => {
      setSubmitted(true);
      setLoading(false);
    }, 1000);
  };

  if (submitted) {
    return (
      <div className="legal-page">
        <section className="legal-hero">
          <div className="container">
            <h1>Inquiry Submitted</h1>
            <p className="legal-subtitle">
              Thank you for contacting our legal team.
            </p>
          </div>
        </section>

        <section className="legal-content">
          <div className="container">
            <div className="deletion-success">
              <div className="success-icon">✅</div>
              <h2>We've Received Your Inquiry</h2>
              <p>
                Our legal team will review your inquiry and respond within 2-3
                business days.
              </p>

              <div className="next-steps">
                <h3>What happens next?</h3>
                <ul>
                  <li>
                    Your inquiry is assigned to the appropriate team member
                  </li>
                  <li>We'll review all relevant documentation and policies</li>
                  <li>You'll receive a detailed response via email</li>
                  <li>Follow-up meetings can be scheduled if necessary</li>
                </ul>
              </div>

              <div className="help-section">
                <p>
                  <strong>Need immediate assistance?</strong> Email our legal
                  team at{" "}
                  <a href="mailto:legal@goalflex.com">legal@goalflex.com</a>
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="legal-page">
      {/* Hero Section */}
      <section className="legal-hero">
        <div className="container">
          <h1>Legal Inquiries</h1>
          <p className="legal-subtitle">
            Get in touch with our legal team for compliance, partnership, or
            legal matters.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="legal-content">
        <div className="container">
          <div className="legal-intro">
            <p>
              Our legal team is here to assist with questions about compliance,
              partnerships, intellectual property, data protection, and other
              legal matters. Please provide as much detail as possible to help
              us respond effectively.
            </p>
          </div>

          <div className="legal-section">
            <h2>Common Legal Topics</h2>
            <div className="subsection">
              <h3>Business Partnerships</h3>
              <ul>
                <li>Venue partnerships and contracts</li>
                <li>Corporate team programs</li>
                <li>Sponsorship opportunities</li>
                <li>Technology integrations</li>
              </ul>
            </div>
            <div className="subsection">
              <h3>Compliance & Regulations</h3>
              <ul>
                <li>Data protection and privacy compliance</li>
                <li>Sports regulation compliance</li>
                <li>International operations</li>
                <li>Accessibility requirements</li>
              </ul>
            </div>
            <div className="subsection">
              <h3>Intellectual Property</h3>
              <ul>
                <li>Trademark and copyright inquiries</li>
                <li>Patent licensing</li>
                <li>Brand usage guidelines</li>
                <li>Content licensing</li>
              </ul>
            </div>
          </div>

          <div className="deletion-form-section">
            <h2>Submit Legal Inquiry</h2>
            <form onSubmit={handleSubmit} className="deletion-form">
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-input"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-input"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="organization">Organization/Company</label>
                <input
                  type="text"
                  id="organization"
                  name="organization"
                  className="form-input"
                  placeholder="Optional - if representing an organization"
                  value={formData.organization}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="inquiryType">Type of Inquiry *</label>
                <select
                  id="inquiryType"
                  name="inquiryType"
                  className="form-select"
                  value={formData.inquiryType}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select inquiry type...</option>
                  <option value="partnership">Business Partnership</option>
                  <option value="compliance">Compliance & Regulations</option>
                  <option value="intellectual-property">
                    Intellectual Property
                  </option>
                  <option value="data-protection">Data Protection</option>
                  <option value="licensing">Licensing</option>
                  <option value="litigation">Litigation</option>
                  <option value="contracts">Contracts</option>
                  <option value="other">Other Legal Matter</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  className="form-input"
                  placeholder="Brief description of your inquiry"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Detailed Message *</label>
                <textarea
                  id="message"
                  name="message"
                  className="form-textarea"
                  placeholder="Please provide detailed information about your legal inquiry, including relevant dates, parties involved, and specific questions..."
                  value={formData.message}
                  onChange={handleChange}
                  rows="6"
                  required
                />
                <p className="form-help">
                  The more detail you provide, the better we can assist you.
                </p>
              </div>

              <div className="form-actions">
                <button
                  type="submit"
                  className="btn-delete"
                  disabled={loading}
                  style={{
                    background: loading
                      ? "#6b7280"
                      : "linear-gradient(135deg, #10b981, #059669)",
                    transform: "none",
                  }}
                >
                  {loading ? "Submitting..." : "Submit Legal Inquiry"}
                </button>

                <div className="alternative-actions">
                  <p>
                    <strong>General support?</strong>
                    <a href="mailto:support@goalflex.com">Contact Support</a>
                  </p>
                </div>
              </div>
            </form>
          </div>

          <div className="legal-section">
            <h2>Contact Information</h2>
            <div className="contact-info">
              <p>
                <strong>Legal Department:</strong>{" "}
                <a href="mailto:legal@goalflex.com">legal@goalflex.com</a>
              </p>
              <p>
                <strong>Mailing Address:</strong>
                <br />
                GoalFlex Legal Department
                <br />
                123 Soccer Street, Suite 400
                <br />
                San Francisco, CA 94105
                <br />
                United States
              </p>
              <p>
                <strong>Business Hours:</strong> Monday - Friday, 9:00 AM - 5:00
                PM PST
              </p>
            </div>
          </div>

          <div className="legal-section">
            <h2>Response Time & Process</h2>
            <ul>
              <li>
                <strong>Standard Inquiries:</strong> 2-3 business days
              </li>
              <li>
                <strong>Partnership Inquiries:</strong> 3-5 business days
              </li>
              <li>
                <strong>Compliance Matters:</strong> 1-2 business days
              </li>
              <li>
                <strong>Urgent Legal Matters:</strong> Same day (call hotline)
              </li>
            </ul>
            <p>
              All inquiries are handled confidentially and in accordance with
              applicable attorney-client privilege and professional standards.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalInquiries;
